<template>
	<div class="tabContainer px-3">
		<div class="d-flex">
			<v-text-field
				v-model="search"
				class="py-0 mr-2"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			/>
			<v-btn @click.stop="addSorting" color="primary">
				<v-icon> mdi-plus</v-icon>
				Add Sorting
			</v-btn>
		</div>
		<div class="tabInnerContainer">
			<v-data-table
				dense
				hide-default-footer
				disable-pagination
				fixed-header
				loading-text="Loading..."
				sort-by="Order"
				:items="reportSorting"
				:headers="headers"
				:search.sync="search"
			>
				<template v-slot:body="props">
					<draggable
						@change="reorder(props.items)"
						:list="props.items"
						tag="tbody"
					>
						<tr v-for="(item, index) in props.items" :key="index">
							<td>
								<v-icon small color="primary"
									>mdi-reorder-horizontal</v-icon
								>
							</td>

							<td>{{ getReportFieldSchema(item) }}</td>
							<td>{{ getReportFieldName(item) }}</td>
							<td>{{ getSortingOperator(item) }}</td>
							<td>
								<v-btn
									fab
									small
									icon
									elevation="1"
									class="action-btn float-right"
									@click.stop="deleteSorting(item)"
								>
									<v-icon color="error" small
										>mdi-delete</v-icon
									>
								</v-btn>
								<v-btn
									fab
									small
									icon
									elevation="1"
									class="action-btn float-right"
									@click.stop="editSorting(item)"
								>
									<v-icon color="primary" small
										>mdi-pencil</v-icon
									>
								</v-btn>
							</td>
						</tr>
					</draggable>
				</template>
			</v-data-table>
		</div>
		<v-container fluid class="mt-2">
			<v-row no-gutters>
				<v-spacer />
				<v-btn text outlined @click="onCancel">Cancel</v-btn>
			</v-row>
		</v-container>
		<report-sorting-modal
			v-if="showDialog"
			:showDialog="showDialog"
			:reportSorting="selectedSorting"
			:index="index"
			@close="hideModal"
		/>
	</div>
</template>
<script>
import ReportSortingModal from './ReportSortingModal.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import Draggable from 'vuedraggable';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { ReportDetailsActions } from '../../../../../store/actions';
import { mapGetters } from 'vuex';
import { reportTypes } from '../../../../../enums/reportTypes';

export default {
	name: 'ReportSorting',
	components: {
		ReportSortingModal,
		Draggable,
	},
	computed: {
		...mapGetters({
			reportSorting: [ReportDetailsGetters.REPORT_SORTING],
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
			reportFields: [ReportDetailsGetters.REPORT_FIELDS],
		}),
		reorderData() {
			let x = this.reportSorting;
			return JSON.parse(
				JSON.stringify(x.sort((a, b) => a.Order - b.Order))
			);
		},
	},
	data() {
		return {
			index: 0,
			showDialog: false,
			showReorderModal: false,
			search: '',
			selectedSorting: null,
			headers: [
				{ text: '', sortable: false, value: 'Draggable', width: 10 },
				{ text: 'Schema', value: 'Schema', sortable: false },
				{ text: 'Field', value: 'Field', sortable: false },
				{ text: 'Direction', value: 'Operator', sortable: false },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
			sortOperators: [
				{ value: 1, label: 'Ascending' },
				{ value: -1, label: 'Descending' },
			],
		};
	},
	methods: {
		reorder(props) {
			this.reordered = props;
			this.reordered.forEach((element) => {
				element.Order = this.reordered.indexOf(element) + 1;
			});
			this.$store.dispatch(ReportDetailsActions.REORDER_REPORT_SORTING, {
				id: this.report.Id,
				data: this.reordered,
			});
		},
		onCancel() {
			this.$router.push({ name: 'ReportBuilder' });
		},
		deleteSorting(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this Report Sorting?',
			}).then((success) => {
				if (!success) return;
				this.$store.dispatch(
					ReportDetailsActions.DELETE_REPORT_SORTING,
					item
				);
			});
		},
		editSorting(item) {
			this.showDialog = true;
			this.selectedSorting = item;
		},
		addSorting() {
			this.index = this.reportSorting.length;
			this.showDialog = true;
		},
		hideModal() {
			this.showDialog = false;
			this.selectedSorting = null;
			this.index = 0;
		},
		getReportFieldName(sorting) {
			if (!this.reportFields) return null;
			let field = this.reportFields.find(
				(x) => x.Id == sorting.ReportFieldId
			);
			if (!field) return null;
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return field.Source;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			return gvf.Label;
		},
		getReportFieldSchema(sorting) {
			if (!this.reportFields) return null;
			let field = this.reportFields.find(
				(x) => x.Id == sorting.ReportFieldId
			);
			if (!field) return null;
			if (this.report.Type == reportTypes.CUSTOM_DATA)
				return this.report.CustomData;
			if (!this.reportGridViewFields) return null;
			let gvf = this.reportGridViewFields.find(
				(x) => x.Id == field.GridViewFieldId
			);
			if (!gvf) return null;
			if (!this.schemas) return null;
			let schema = this.schemas.find((x) => x.Id == gvf.EntityId);
			if (!schema) return null;
			return schema.Name;
		},
		getSortingOperator(sorting) {
			let operator = this.sortOperators.find(
				(x) => x.value == sorting.Operator
			);
			if (!operator) return null;
			return operator.label;
		},
	},
};
</script>
<style lang="scss" scoped>
.tabContainer {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
	.tabInnerContainer {
		flex-grow: 1;
	}
}
</style>
